export enum ReadingLevel {
  MODALITY = 'MODALITY',
  VISIT = 'VISIT',
  PATIENT = 'PATIENT',
  LONGITUDINAL = 'LONGITUDINAL'
}
